import { useUploadImage } from '@/hooks/useUploadImage'
import {
  UploadVideoToBlendVisionServiceParams,
  useUploadVideoToBlendVisionService,
} from '@/hooks/useUploadVideoToBlendVisionService'

export const useUploadMediaToService = () => {
  const { uploadImage } = useUploadImage()
  const { uploadVideoToBlendVisionService } = useUploadVideoToBlendVisionService()

  const uploadMediaToService = async (params: UploadVideoToBlendVisionServiceParams) => {
    const { file } = params

    if (!file) {
      return
    }

    try {
      if (file.type.includes('video')) {
        return await uploadVideoToBlendVisionService(params)
      } else {
        return await uploadImage(file)
      }
    } catch (error) {
      console.error(`❌ upload to service failed: ${file.name} `, error)
    }
  }

  return uploadMediaToService
}
